export default __webpack_public_path__ + "static/media/167.24ba3f91.svg";